// src/utils/ga4.js
//Esto es para Analytics de Google
import ReactGA from "react-ga4";

const GA_MEASUREMENT_ID = process.env.REACT_APP_GOOGLE_ANALYTICS_ID;

export const initGA = () => {
  ReactGA.initialize([
    {
      trackingId: GA_MEASUREMENT_ID,
      gaOptions: {
        send_page_view: false, // 🔒 Desactiva pageviews automáticos
      },
    },
  ]);
};

export const sendPageView = (path) => {
  ReactGA.send({ hitType: "pageview", page: path });
};

export const sendEvent = ({ category, action, label }) => {
  ReactGA.event({
    category,
    action,
    label,
  });
};